import React from "react";
import {FormDialog, SelectElementModelFE} from "../../../api/types/generic";
import {FormAutocomplete} from "../../../common/form-fields";
import {useTranslation} from "react-i18next";
import {ProductCodeSelectFE} from "../../../api/types/productCode";
import {ProductCodeLocationGroupAssociation} from "../../../api/types/exceptionListProductCodeLocationGroup";

export default ({
                    nestIndex,
                    formDialog,
                    options,
                    handleChange,
                    name,
                    getValues
                }: {
    nestIndex: number,
    formDialog: FormDialog | null,
    options: any,
    handleChange: Function,
    name: string,
    getValues: Function
}) => {

    // Use Translation
    const {t} = useTranslation(["translation", "pricing"]);

    return (
        <FormAutocomplete
            name={`associations.${nestIndex}.${name}`}
            label={`${t("pricing:exceptionListProductCodeLocationGroup.form.labels." + name)}`}
            options={options}
            isOptionEqualToValue={(option: SelectElementModelFE, value: SelectElementModelFE) => {
                return value?.code === option?.code;
            }}
            readOnly={Boolean(formDialog?.readonly) || Boolean(formDialog?.inUse)}
            multiple={true}
            handleChange={(value: SelectElementModelFE[]) => handleChange(value, nestIndex)}
            getOptionDisabled={(option) => {
                return Boolean(getValues()?.associations?.find((association: ProductCodeLocationGroupAssociation) => {
                    return association.productCode?.find((pc: ProductCodeSelectFE) => pc.code === option.code);
                })) || false;
            }}
        />
    );
};
